import React, {forwardRef, useImperativeHandle, useState} from 'react';
import {Modal, Button} from 'react-bootstrap';

const InfoModal = forwardRef(({title, description}, ref) => {
    const [modalShow, setModalShow] = useState(false);

    useImperativeHandle(ref, () => ({
        openModal: () => setModalShow(true),
        closeModal: () => setModalShow(false),
    }));

    return (
        <Modal
            show={modalShow}
            onHide={() => setModalShow(false)}
            size="xl"
            scrollable
            aria-labelledby="contained-modal-title-vcenter"
            centered
            keyboard
            animation
            autoFocus
        >
            <Modal.Header closeButton>
                <Modal.Title id="contained-modal-title-vcenter">
                    {title}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <p>
                    {description}
                </p>
            </Modal.Body>
        </Modal>
    );
});

export default InfoModal;
